export default "__VITE_ASSET__DPzpgdMw__"